import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ViewBasePage } from '@shared/pages';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@Component({
    'selector': 'app-marketing',
    'templateUrl': './marketing.page.html',
    'styleUrls': ['./marketing.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class MarketingPage extends ViewBasePage implements OnInit, OnDestroy {
    public onDevice = false;

    constructor(private platform: Platform,  injector: Injector) {
        super(injector);
        super.setCurrentView(this.Constants.VIEW_MARKETING);
    }

    // ngOnInit(): void {
    //     super.ngOnInit();

    //     // Changing channels must be done on a phone.
    //     // Don't show the channels option if running on a desktop machine
    //     this.onDevice = this.platform.is('cordova');
    // }

    public ionViewWillEnter() {
        super.setCurrentView(this.Constants.VIEW_MARKETING);
        super.ngOnInit();

        // Changing channels must be done on a phone.
        // Don't show the channels option if running on a desktop machine
        this.onDevice = this.platform.is('cordova');
        // this.initMoreMenu()
    }

    public ionViewWillLeave() {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-marketing-tour');
    // }

    public onCampaignsClick(): void {
        this.router.navigateByUrl('/marketing/campaigns');
    }

    public onCustomersClick(): void {
        this.router.navigateByUrl('/marketing/customers');
    }

    public onIncentiveSetsClick(): void {
        this.router.navigateByUrl('/marketing/campaignIncentiveSets');
    }

    public onCampaignIncentivesClick(): void {
        this.router.navigateByUrl('/marketing/campaignIncentives');
    }

    public onCampaignMessageClick(): void {
        this.router.navigateByUrl('/marketing/campaignMessage');
    }

    public onCampaignHostingClick(): void {
        this.router.navigateByUrl('/marketing/campaignHosting');
    }

    public onFormatSelectorClick(): void {
        this.router.navigateByUrl('/marketing/campaignFormatSelector');
    }
}
